export default "__VITE_ASSET__DUWGm$TL__"